<template>
  <div>
    <LDBsTable
      url="arena/vehicles-and-areas-generate-events"
      defaultSort="ARV_DHI"
      defaultOrder="desc"
      :query="queryToUse"
      :columns="columns"
      :clear="clear"
      :defaultOptions="options"
    >
      <div class="form-group col-lg-12">
        <label for="client">{{ $t("client") }}</label>
        <Combobox
          class="bg-white"
          name="client"
          :placeholder="$t('select_a_item')"
          :options="clients"
          :initial-value="query.CLI_ID"
          label="CLI_DSC"
          v-model="query.CLI_ID"
          :reduce="(client) => client.CLI_ID"
        />
      </div>

      <div class="form-group col-lg-6">
        <label for="vehicle">{{ $t("vehicle") }}</label>
        <Combobox
          class="bg-white"
          name="vehicle"
          :placeholder="$t('select_a_item')"
          :options="vehiclesByClient"
          :initial-value="query.VEI_ID"
          :getOptionLabel="vehicle => mountVehicleLabel(vehicle)"
          v-model="query.VEI_ID"
          :reduce="(vehicle) => vehicle.id"
        />
      </div>

      <div class="form-group col-lg-6">
        <label for="area">{{ $t("area") }}</label>
        <Combobox
          class="bg-white"
          name="area"
          :placeholder="$t('select_a_item')"
          :options="areasByClient"
          :initial-value="query.ARE_ID"
          label="ARE_DSC"
          v-model="query.ARE_ID"
          :reduce="(area) => area.id"
        />
      </div>
    </LDBsTable>

    <!-- MODAL CONFIRM REMOVE -->
    <div
      class="modal fade"
      id="modalConfirmRemove"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalConfirmRemoveLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalConfirmRemoveLabel">
              Remover vínculo
            </h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <ul>
              <li>
                VEÍCULO: <strong>{{ dataToRemove.vehicleName }}</strong>
              </li>
              <li>
                ÁREA: <strong>{{ dataToRemove.areaName }}</strong>
              </li>
              <li>
                CLIENTE: <strong>{{ dataToRemove.clientName }}</strong>
              </li>
            </ul>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              :disabled="isLoading"
            >
              {{ $t("close") }}
            </button>

            <LoaderButton
              class="mt-3"
              @click="unlink"
              :loading="isLoading"
            >
              {{ $t("confirm") }}
            </LoaderButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LDBsTable from "@/components/shared/LDBsTable";
import Combobox from "@/components/shared/ComboBox";
import { mapState } from "vuex";
import moment from 'moment';
import LoaderButton from '@/components/button/LoaderButton'

export default {
  name: "ArenaLinkVehicleAndAreaGenerateEventsList",

  components: {
    LDBsTable,
    Combobox,
    LoaderButton
  },

  data() {
    return {
      columns: [
        {
          title: this.$t("vehicle"),
          field: "vehicleName",
          sortable: false,
        },
        {
          title: this.$t("area"),
          field: "areaName",
          sortable: false,
        },
        {
          title: this.$t("client"),
          field: "clientName",
          sortable: false,
        },
        {
          title: this.$t("home"),
          field: "ARV_DHI",
          sortable: false,
          formatter: (value) => {
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
          },
        },
        {
          title: this.$t("end"),
          field: "ARV_DHF",
          sortable: false,
          formatter: (value) => {
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
          },
        },
        {
          key: "id",
          field: "VEI_ID",
          align: "center",
          width: "100%",
          formatter: function (value, row) {
            // <a
            //   href="#/main/arena/edit-vehicle-and-area/${value}"
            //   class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
            // >
            //   <i class="fas fa-pen" />
            // </a>
            return `
              <button
                title="Remover vínculo"
                data-target="#modalConfirmRemove"
                data-id='${value}'
                data-areid='${row.ARE_ID}'
                data-arvdhi='${row.ARV_DHI}'
                data-arvdhf='${row.ARV_DHF}'
                data-arvdhf='${row.ARV_DHF}'
                data-vehiclename='${row.vehicleName}'
                data-clientname='${row.clientName}'
                data-areaname='${row.areaName}'
                data-toggle="modal"
                class="edit mb-1 btn btn-action btn-danger btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-times" />
              </button>
            `;
          },
        },
      ],
      options: {
        exportOptions: { fileName: "arena_veiculos_areas" },
      },
      queryToUse: {},
      query: {
        VEI_ID: undefined,
        ARE_ID: undefined,
        CLI_ID: undefined,
      },
      dataToRemove: {}
    };
  },

  computed: {
    ...mapState({
      lastquery: (state) => state.filtershistory.query,
      clients: (state) => state.arena.clients,
      vehicles: (state) => state.arena.vehicles,
      areas: (state) => state.arena.areas,
      isLoading: (state) => state.arena.isLoading,
    }),

    vehiclesByClient() {
      if (this.query.CLI_ID) {
        return this.vehicles.filter(vehicle => vehicle.CLI_ID == this.query.CLI_ID);
      }

      return this.vehicles
    },

    areasByClient() {
      if (this.query.CLI_ID) {
        return this.areas.filter(area => area.CLI_ID == this.query.CLI_ID);
      }

      return this.areas
    }
  },

  methods: {
    clear() {
      this.query.ARE_ID = undefined;
      this.query.VEI_ID = undefined;
      this.query.CLI_ID = undefined;
    },

    upper(attr) {
      this.query[attr] = this.query[attr].toUpperCase();
    },

    mountVehicleLabel(vehicle) {
      const { EQP_SRN, VEI_DSC, VEI_PLC } = vehicle

      const fields = [EQP_SRN, VEI_DSC, VEI_PLC]

      return fields.join(' / ')
    },

    async unlink() {
      await this.$store.dispatch(
        'arena/unlinkVehicleAndAreaGenerateEvents',
        this.dataToRemove
      )

      $("#modalConfirmRemove").modal("hide");
      $("#search").trigger("click");
    }
  },

  beforeMount() {
    this.queryToUse = this.lastquery["arenalinkvehicleandareagenerateevents"]
      ? this.lastquery["arenalinkvehicleandareagenerateevents"]
      : this.query;
  },

  async mounted() {
    const { dispatch } = this.$store;

    await Promise.all([
      dispatch("arena/fetchClients"),
      dispatch(
        "arena/fetchVehicles",
        { viewLinkVehicleAndArea: true }
      ),
      dispatch("arena/fetchAreas"),
    ])

    if (this.lastquery["arenalinkvehicleandareagenerateevents"]) {
      for (const [key, value] of Object.entries(
        this.lastquery["arenalinkvehicleandareagenerateevents"]
      )) {
        this.query[key] = value;
      }
    }

    this.queryToUse = this.query;

    const global = this;

    $("#modalConfirmRemove").on("show.bs.modal", function (event) {
      const button = $(event.relatedTarget);

      global.dataToRemove = {
        VEI_ID: button.data("id"),
        ARE_ID: button.data("areid"),
        ARV_DHI: button.data("arvdhi"),
        ARV_DHF: button.data("arvdhf"),
        vehicleName: button.data("vehiclename"),
        clientName: button.data("clientname"),
        areaName: button.data("areaname"),
      }
    });

    $("#modalConfirmRemove").on("hide.bs.modal", function (event) {
      global.dataToRemove = {}
    });
  },

  destroyed() {
    this.$store.dispatch("filtershistory/setQuery", {
      key: "arenalinkvehicleandareagenerateevents",
      query: this.query,
    });
  },
};
</script>
